<template>
    <div class="com2" :class="{'bor': bor===true}">
        我是组件2
    </div>
</template>
<script>
export default {
    name: 'comTwo',
    props: {
        bor: {
            type: Boolean,
            default: false
        }
    }
}
</script>
<style lang="scss" scoped>
    .com2{
        height: 50px;
        background: blue;
        color: #fff;
        font-size: 16px;
    }
    .bor{
        border: 2px solid green;
    }
</style>